import React, { useState, useRef, useEffect } from "react";
import "./Test.css";
import { END_URL } from "../../config";
import axios from "axios";
import { IMG_URL } from "../../config";
import dum from "../../images/modal1.png";
import gg from "../../images/pp-logo.gif";

const FreeTestDetail = ({
  testData,
  allQuestions,
  handleResults,
  BannerImage,
  BannerContent,
  onNavHide,
  TestColor,
  slug,
  TestIntro
}) => {
  const sliderRefs = useRef([]);
  const isDragging = useRef(false);
  const [banner, setBanner] = useState(null);
  const [loadingBanner, setLoadingBanner] = useState(true);
  const [showLoader, setShowLoader] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [editingIndex, setEditingIndex] = useState(null);
  const containerRef = useRef(null);
  const [scrolledPast, setScrolledPast] = useState(false);

  useEffect(() => {
    if (allQuestions && allQuestions.length > 0) {
      setQuestions(allQuestions);
    }
  }, [allQuestions]);


  useEffect(() => {

    if(BannerImage)
    {
      setShowLoader(false);
    }
   
  }, [BannerImage]);

  // useEffect(() => {
  //   const fetchBanner = async () => {
  //     try {
  //       if (!slug) return;
  //       const res = await axios.get(`${END_URL}/starter_quiz_banner/${slug}`);
  //       setBanner(res.data?.starter_quiz_banner?.starter_quiz_banner || null);
  //     } catch (err) {
  //       console.error("Error fetching banner:", err);
  //     } finally {
  //       setLoadingBanner(false);
  //     }
  //   };

  //   fetchBanner();
  // }, [slug]);

  // useEffect(() => {
  //   if (!loadingBanner) {
  //     const timer = setTimeout(() => setShowLoader(false), 500);
  //     return () => clearTimeout(timer);
  //   }
  // }, [loadingBanner]);

  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      if (!container) return;

      const containerBottom = container.offsetTop + container.offsetHeight;
      const scrollY = window.scrollY + 170;

      setScrolledPast(scrollY > containerBottom);
      onNavHide(scrollY > containerBottom);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleStartDrag = (e, displayIndex, actualIndex) => {
    e.preventDefault();
    isDragging.current = true;

    const moveHandler = (e) => {
      let clientX;
      if (e.type.startsWith("touch")) {
        clientX = e.touches[0].clientX;
      } else {
        clientX = e.clientX;
      }

      const sliderRef = sliderRefs.current[displayIndex];
      if (!sliderRef) return;

      const rect = sliderRef.getBoundingClientRect();
      let newX = clientX - rect.left;
      let percent = (newX / rect.width) * 100;

      percent = Math.max(0, Math.min(100, percent));

      const result = percent < 50 ? -(100 - percent * 2) : (percent - 50) * 2;

      setQuestions((prevQuestions) => {
        const updatedQuestions = prevQuestions.map((q, idx) => {
          if (idx === actualIndex) {
            return { ...q, value: percent, result, answered: true };
          }
          return q;
        });
        handleResults(updatedQuestions);
        return updatedQuestions;
      });
    };

    const endHandler = () => {
      isDragging.current = false;
      document.removeEventListener("mousemove", moveHandler);
      document.removeEventListener("mouseup", endHandler);
      document.removeEventListener("touchmove", moveHandler);
      document.removeEventListener("touchend", endHandler);

      // Auto-scroll to next question and unlock it
      const normalQuestions = questions.filter(q => q.specialquestions === "N");
      
      if (displayIndex < normalQuestions.length - 1) {
        const newActiveIndex = displayIndex + 1;
        setActiveIndex(newActiveIndex);

        // Scroll to next question
        setTimeout(() => {
          const sections = document.getElementsByClassName("test-box1");
          if (sections[newActiveIndex]) {
            const nextSectionTop =
              sections[newActiveIndex].getBoundingClientRect().top +
              window.scrollY -
              100;
            window.scrollTo({ top: nextSectionTop, behavior: "smooth" });
          }
        }, 100);
      }
    };

    document.addEventListener("mousemove", moveHandler);
    document.addEventListener("mouseup", endHandler);
    document.addEventListener("touchmove", moveHandler, { passive: false });
    document.addEventListener("touchend", endHandler);
  };

  if (showLoader) {
    return (
      <div className="loadingDiv">
        <img src={gg} alt="Loading..." />
      </div>
    );
  }

  // const firstCategory = testData && testData.length > 0 ? testData[0] : null;

  const normalQuestions = questions
    .map((q, originalIndex) => ({ ...q, originalIndex }))
    .filter((q) => q.specialquestions === "N");

  return (
    <>
      { BannerImage && BannerContent && (
        <div className="test-banner banner-top">
          <div
            className="container-fluid test-content-imgDiv"
            ref={containerRef}
          >
            <div className="row">
              <div
                className="test-all-cont"
                style={{
                  background:`url(${IMG_URL}/d0/${BannerImage}) no-repeat center center`,
                  backgroundSize: "cover",
                }}
              >
                <div className="test-all-img"></div>
                <div
                  className="test-content-outer1"
                  dangerouslySetInnerHTML={{
                    __html: BannerContent,
                  }}
                />
              </div>

                 <div className="full-test-page intro-test-content-outer"
                  style={{
                          "--content-outer": `${TestIntro?.note_color}`,
                        }}
                 >

                    <span> <img src={`${IMG_URL}/d0/${TestIntro?.test_note_image}`} /> </span>
                    
                    <div
                          className="intro-test-content"
                          dangerouslySetInnerHTML={{
                            __html: TestIntro?.test_intro_note,
                      }}
                    />

                </div>

            </div>
          </div>
        </div>
      )}

      <div className="container">

        {/* {!BannerImage && firstCategory && (
          <div className="row test-title-row test-title-row-not-banner banner-top">
            <div className="test-title">
              <div
                className="test-content-outer"
                dangerouslySetInnerHTML={{
                  __html: firstCategory.longdescription,
                }}
              />
            </div>
          </div>
        )} */}

        <div className="row test-progress-row">
          <div className="col-12">
            <div className="test-progress-col position-relative w-100 mx-auto">
              {normalQuestions.map((question, displayIndex) => {
                const sliderValue = question.value ?? 50;
                const percentFromCenter =
                  sliderValue >= 50
                    ? (sliderValue - 50) * 2
                    : (50 - sliderValue) * 2;

                  const dynamicColor =
                  sliderValue === 50
                    ? "#7e9ead"
                    : sliderValue < 50
                    ? TestColor?.left_color_1 || "#69bd8f"
                    : TestColor?.right_color_1 || "#ffb3ff";

                return (
                  <div
                    key={question.originalIndex}
                    className="test-box1"
                    style={{
                      opacity:
                        displayIndex === 0 ||
                        question.answered ||
                        displayIndex <= activeIndex
                          ? 1
                          : 0.3,
                      pointerEvents:
                        displayIndex === 0 ||
                        question.answered ||
                        displayIndex <= activeIndex
                          ? "auto"
                          : "none",
                      transition:
                        "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
                    }}
                    onMouseEnter={() => setEditingIndex(displayIndex)}
                    onMouseLeave={() => setEditingIndex(null)}
                    onTouchStart={() => setEditingIndex(displayIndex)}
                    onTouchEnd={() => setEditingIndex(null)}
                  >
                    <div className="test-t3-p">
                      <p>
                        {/* <strong>{question.category_name}:</strong>{" "} */}
                        {question.question}
                      </p>
                    </div>

                    <div className="test-content-div">

                        <div
                          className="test-content-one"
                          dangerouslySetInnerHTML={{ __html: question.option_1 }}
                          style={{
                                border: "2px solid transparent",
                                background: `
                                  linear-gradient(#fff, #fff) padding-box,
                                  linear-gradient(180deg, ${TestColor?.left_color_1}, #7e9ead) border-box
                                `,
                                borderRadius: "12px"
                          }}
                        />

                        <div
                          className="test-content-two"
                          dangerouslySetInnerHTML={{ __html: question.option_2 }}
                          style={{
                                    border: "2px solid transparent",
                                    background: `
                                      linear-gradient(#fff, #fff) padding-box,
                                      linear-gradient(180deg, ${TestColor?.right_color_1}, #7e9ead) border-box
                                    `,
                                    borderRadius: "12px"
                          }}
                        />

                    </div>

                    <div className="test-progress-bar">
                      <div className="test-progress-bar-inner position-relative w-100 mx-auto">
                        <div
                          className="test-cover-bar-div bg-light rounded-pill position-relative w-100 overflow-visible"
                          ref={(el) => (sliderRefs.current[displayIndex] = el)}
                        >
                          <div
                            className="test-color-part position-absolute top-0 h-100"
                            style={{
                              width: "100%",
                              background: `linear-gradient(to right, 
                                ${
                                  TestColor?.left_color_1 ||
                                  "rgb(105, 189, 143)"
                                } 0%, 
                                ${
                                  TestColor?.left_color_2 ||
                                  "rgb(234, 255, 233)"
                                } 50%, 
                                ${
                                  TestColor?.right_color_2 ||
                                  "rgb(255, 233, 255)"
                                } 50%, 
                                ${
                                  TestColor?.right_color_1 ||
                                  "rgb(255, 179, 255)"
                                } 100%)`,
                            }}
                          ></div>

                          <div
                            className="test-scroll-part position-absolute shadow-sm rounded-circle"
                            style={{
                              left: `${sliderValue}%`,
                              top: "50%",
                              transform: "translate(-50%, -50%)",
                              width: "25px",
                              height: "25px",
                              cursor: "pointer",
                              zIndex: 2,
                              touchAction: "none",
                              backgroundColor: dynamicColor,
                            }}
                            onMouseDown={(e) => handleStartDrag(e, displayIndex, question.originalIndex)}
                            onTouchStart={(e) => handleStartDrag(e, displayIndex, question.originalIndex)}
                          ></div>

                          <div
                            className="slider-percentage-label"
                            style={{
                              position: "absolute",
                              left: `${sliderValue}%`,
                              top: "110%",
                              transform: "translateX(-50%)",
                              fontSize: "14px",
                              color: dynamicColor,
                              fontWeight: "900",
                              pointerEvents: "none",
                              zIndex: 3,
                            }}
                          >
                            {Math.round(percentFromCenter)}%
                          </div>
                        </div>

                        <div className="d-flex justify-content-between text-secondary test-name-points">
                          <span>Fully</span>
                          <span>Somewhat</span>
                          <span>Neutral</span>
                          <span>Somewhat</span>
                          <span>Fully</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FreeTestDetail;